// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2F9WF","inputWrap":"Table_inputWrap__3PGmI","col":"Table_col__LN4Vt","bmiTooltip":"Table_bmiTooltip__2bInr"};